// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__2Z4qR","rootSmall":"AddTileButton_rootSmall__2D6uJ"};